'use strict';

module.exports = {
  minimumAge: 18,
  cookieName: 'rlink-agegate-birthday',
};



// WEBPACK FOOTER //
// ./lib/rlink-agegate/ageGateConfig.js